import React from 'react';
import {
    Note,
    Tone
} from '../model/core';
import { Tonality } from '../model/scales';
import _ from 'lodash';
import { wrap } from './RydTestbedWrap';
import {
    activeIfC,
    HighlightPredicate,
    RydFretboard
} from '../components/widgets/RydFretboard';
import { TonalityInputBox } from '../components/pickers/ContextTonality';

const isToneCenter = (n: Note, root?: Tone) => n.getTone().index === root?.index ? ['piano-roll--tonality--center'] : [];
const isInTonality = (n: Note, tonality?: Tonality) => {
    if (!tonality) return [];
    const isInTonality = tonality.containsNote(n);
    return isInTonality ? ["piano-roll--tonality-note"] : ["piano-roll--non-tonality-note"];
}
// const activeIfCMinorMelodic = (stringIndex: number, fret: number, baseNote: number) => {

const highlightPredicates: HighlightPredicate[] = [
    activeIfC,
];

export function EurydiceFretboardTestbed() {
    const [numberOfFrets, setNumberOfFrets] = React.useState(24);
    const [numberOfStrings, setNumberOfStrings] = React.useState(6);
    const [tuningInput, setTuningInput] = React.useState("E4, A4, D5, G5, B5, E6");

    const [tonalityForStyling, setTonalityForStyling] = React.useState<Tonality | undefined>(undefined);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Here you could add additional logic if needed when the form is submitted.
    };

    const tuning = tuningInput.split(',').map(note => Note.fromName(note.trim()).index);

    return wrap(
        <div>
            <h1>Eurydice Fretboard Testbed</h1>
            <h2>simple</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>
                        Number of Frets:
                        <input
                            type="number"
                            value={numberOfFrets}
                            onChange={(e) => setNumberOfFrets(Number(e.target.value))}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        Number of Strings:
                        <input
                            type="number"
                            value={numberOfStrings}
                            onChange={(e) => setNumberOfStrings(Number(e.target.value))}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        Tuning (comma separated):
                        <input
                            type="text"
                            value={tuningInput}
                            onChange={(e) => setTuningInput(e.target.value)}
                        />
                    </label>
                </div>
                <button type="submit">Update Config</button>
            </form>

            <RydFretboard config={{
                numberOfFrets,
                numberOfStrings,
                tuning,
            }}
                highlightPredicates={highlightPredicates} />

            <h2>Note Highlighter (stylingSource)</h2>
            <div>
                <label>
                    Highlighted Note:
                    <input
                        type="text"
                        value={tuningInput}
                        onChange={(e) => setTuningInput(e.target.value)}
                    />
                </label>
                <label>Tonality</label>
                <TonalityInputBox
                    setTonalityCB={setTonalityForStyling}
                    autoClose={false}
                    tonality={tonalityForStyling}
                />
                <p>Tonality: {tonalityForStyling?.center.getName()} {tonalityForStyling?.scalePattern.pattern.name}</p>
                <RydFretboard
                    config={{
                        numberOfFrets,
                        numberOfStrings,
                        tuning,
                    }}
                    stylingSource={(n: Note) => {
                        if (!tonalityForStyling) return [];
                        return [
                            (n) => tonalityForStyling.center.index === n.getTone().index ? ['fretboard--cell--tonality-center'] : [],
                            (n) => tonalityForStyling.containsNote(n) ? ['fretboard--cell--tonality-note'] : []
                        ].map((f) => f(n)).flat();
                    }}
                />
            </div>
        </div>
    );
}